import React from "react";

import TicketHeader from "./TicketHeader";
import PDFViewer from "./../PDFViewer.js";

const Ticket = ({
  ticketid = "",
  workflowtype = "",
  assignedto = "",
  priority = "",
  subject = "",
  creationdate = new Date(),
  signedURL,
  lob,
  status,
  dcn,
}) => {
  const isPdf = (fileName) => {
    return fileName && fileName.toLowerCase().includes(".pdf");
  };
  const fileName = decodeURIComponent(signedURL?.split("/").pop()?.split("?")[0] || "file");

  return (
    <div>
      <TicketHeader
        ticketId={ticketid}
        type={workflowtype}
        subject={subject}
        assignee={assignedto}
        createadAt={creationdate}
        lob={lob}
        dcn={dcn}
        status={status}
      />
      {signedURL && (
        <div className="mt-2 mb-3 rounded-md border border-gray-200 bg-white shadow-sm px-3 py-2 flex items-center gap-3 justify-between">
          <div className="flex items-center gap-3 min-w-0">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-blue-50 text-blue-700 font-16-600">
              ⬇
            </span>
            <div className="min-w-0">
              <p className="font-16-600 text-black-3 m-0">Document</p>
              <p className="font-14-400-20 text-black-4 m-0 break-all truncate" title={fileName}>
                {fileName}
              </p>
              <p className="font-12-400 text-black-4 m-0">
                {isPdf(signedURL) ? "Preview below" : "Download to view"}
              </p>
            </div>
          </div>
          <a
            href={signedURL}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-lg font-16-600 shadow-sm whitespace-nowrap"
            style={{
              background: "#eef2f7",
              color: "#111827",
              padding: "10px 18px",
              border: "1px solid #cdd5e3",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            <img src="/download.svg" alt="" className="size-16" style={{ filter: "none" }} />
            Download
          </a>
        </div>
      )}
      {signedURL && isPdf(signedURL) && <PDFViewer doc={signedURL} />}
    </div>
  );
};

export default Ticket;
